import { render } from "./TheWatchList.vue?vue&type=template&id=be1a6eec&scoped=true&ts=true"
import script from "./TheWatchList.vue?vue&type=script&lang=ts"
export * from "./TheWatchList.vue?vue&type=script&lang=ts"

import "./TheWatchList.vue?vue&type=style&index=0&id=be1a6eec&scoped=true&lang=css"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be1a6eec"]])

export default __exports__